import * as React from 'react';

import _t from 'i18n!nls/refund';

import 'css!./__styles__/RefundReasonShortAnswerContent';

type Props = {
  setAnswer: (answer: string) => void;
  description: React.ReactNode;
};

class RefundReasonShortAnswerContent extends React.Component<Props> {
  handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    const reason = e.target.value;
    this.props.setAnswer(reason);
  };

  render() {
    const { description } = this.props;
    return (
      <div className="rc-RefundReasonShortAnswerContent">
        <p>{description}</p>
        <textarea
          className="textarea"
          name="refund-reason-text"
          onChange={this.handleTextChange}
          placeholder={_t('Write your feedback here...')}
        />
      </div>
    );
  }
}

export default RefundReasonShortAnswerContent;
